import React from 'react';
import { createPortal } from 'react-dom';
import { motion } from 'framer-motion';

const Loader = ({ visible }) => {
  if (!visible) return null;

  const loaderContent = (
    <motion.div
      className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 backdrop-blur-sm"
      style={{ 
        zIndex: 9999, 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%'
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="relative">
        {/* Main loader circle */}
        <motion.div
          className="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full"
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
        
        {/* Inner circle */}
        <motion.div
          className="absolute top-2 left-2 w-12 h-12 border-4 border-gray-100 border-b-indigo-600 rounded-full"
          animate={{ rotate: -360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
        />
        
        {/* Center dot */}
        <motion.div
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-blue-600 rounded-full"
          animate={{ scale: [1, 1.5, 1] }}
          transition={{ duration: 1, repeat: Infinity }}
        />
      </div>
      
      {/* Loading text */}
      <motion.p
        className="absolute bottom-1/3 text-gray-600 font-medium text-sm sm:text-base"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        Loading...
      </motion.p>
    </motion.div>
  );

  // Render to document.body to ensure it's always on top
  return typeof document !== 'undefined' 
    ? createPortal(loaderContent, document.body)
    : loaderContent;
};

export default Loader;
